/**
 * The locations route tree — three sibling routes, mirroring `support/routes.tsx`'s shape.
 * `/new` is declared before `/:id`, the same ordering `content/routes.tsx` uses for `:type/new`,
 * so a literal `new` never falls through to the numeric-id route.
 *
 * Mounted only for `admin`/`manager` in `App.tsx`, because the detail route and everything nested
 * under it carries IP addresses, gaming licence numbers, and OTC PINs — the same bar as the Content
 * Console. The list screen itself reads the narrower `GET /api/admin/locations`, which every staff
 * role including `agente` already reaches; that route stays open regardless of how this tree is
 * gated, but this dashboard only exposes the list to the roles that can also open a location.
 */
import type { ReactElement } from 'react';
import { Route, Routes } from 'react-router-dom';

import { LocationCreateForm } from './LocationCreateForm.tsx';
import { LocationDetailPage } from './LocationDetailPage.tsx';
import { LocationListPage } from './LocationListPage.tsx';

export { locationPath, locationsRoutePath, newLocationRoutePath } from './paths.ts';

export const LocationsRouteTree = (): ReactElement => (
  <Routes>
    <Route path="/" element={<LocationListPage />} />
    <Route path="/new" element={<LocationCreateForm />} />
    <Route path="/:id" element={<LocationDetailPage />} />
  </Routes>
);
